import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {
   @Input() title;
   @Input() model;
   @Input() redirect;
   @Input() data;
   @Input() button1;
   @Input() button2;
  constructor(public router: Router) { }

  ngOnInit() {
  }
  close(){
    if(this.redirect != "")
      this.router.navigate([this.redirect], this.data);
    this.model.close();
  }
  ok(){
    if(this.redirect != "")
      this.router.navigate([this.redirect], this.data);
    this.model.close();
  }
}




// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/modal/modal.component.ts